import retailerProgramme from './retailerProgramme'
import transportTypes from './transportTypes'

export default function dueDiligence(instance) {
	return {
		retailerProgramme: retailerProgramme(instance),
		transportTypes: transportTypes(instance)
	}
}
